import api from "./api";

function toQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.set(key, String(value));
    }
  });
  return query.toString();
}

export async function listExternalDeployments(filters = {}) {
  const query = toQuery(filters);
  const res = await api.get(`/external-deployments${query ? `?${query}` : ""}`);
  return res.data;
}

export async function getExternalDeployment(id) {
  const res = await api.get(`/external-deployments/${id}`);
  return res.data;
}

export async function createExternalDeployment(payload) {
  const res = await api.post("/external-deployments", payload);
  return res.data;
}

export async function requestExternalDeployment(id, payload = {}) {
  const res = await api.post(`/external-deployments/${id}/request`, payload);
  return res.data;
}

export async function releaseExternalDeployment(id, payload = {}) {
  const res = await api.post(`/external-deployments/${id}/release`, payload);
  return res.data;
}

export async function submitExternalProof(id, payload = {}) {
  const res = await api.post(`/external-deployments/${id}/proof`, payload);
  return res.data;
}

export async function verifyExternalProof(id, proofId, payload = {}) {
  const res = await api.post(`/external-deployments/${id}/proof/${proofId}/verify`, payload);
  return res.data;
}

export async function sendExternalConfirmation(id, payload = {}) {
  const res = await api.post(`/external-deployments/${id}/send-confirmation`, payload);
  return res.data;
}
